import { render } from "./SaldoDisplay.vue?vue&type=template&id=b11087c4&ts=true"
import script from "./SaldoDisplay.vue?vue&type=script&lang=ts"
export * from "./SaldoDisplay.vue?vue&type=script&lang=ts"

import "./SaldoDisplay.vue?vue&type=style&index=0&id=b11087c4&lang=scss"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.3.0_webpack@5.92.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__